
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/allshop.css";
import "../../styles/cartpop.css";
import { motion, AnimatePresence } from "framer-motion";
import { makeApi } from "../../api/callApi";
import Loader from "../../components/loader/loader";
import FooterBar from "../footrt/FooterBar";
import { getImageUrl } from "../../utils/helper.jsx";
import { LocalStorageUtils } from "../../utils/localstorage.utils.jsx";
import MiniCart from "./Minicart";
import AnalyticsService from "services/analytics.service";
import { MerchantApi } from "api/merchant.api";
import { EVENT_NAME } from "utils/constants";

function Allshoppage() {
  const [merchantDisplayList, setMerchantDisplayList] = useState([]);
  const [filteredMerchantDisplayList, setFilteredMerchantDisplayList] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchingProducts, setIsSearchingProducts] = useState(false);
  const [cart, setCart] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [topsall, setTopsall] = useState([]);

  async function fetchMerchantDisplayList() {
    setLoading(true);
    try {

      const response = await MerchantApi.getMerchantDisplayList();

      setMerchantDisplayList(response);
      setFilteredMerchantDisplayList(response); // Initially display all categories
    } catch (error) {
      console.log("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  }

  // Fetch categories on mount
  useEffect(() => {
    fetchMerchantDisplayList();
  }, []);
  
/*   useEffect(() => {
    async function fetchCategories() {
      setLoading(true);
      try {
        const response = await makeApi("/api/gettopsaller", "GET");
        const sortedProducts = response.data.products.sort(
          (a, b) => a.FinalPrice - b.FinalPrice
        );

        // Add default shop and price for products with shopPrices
        const updatedProducts = sortedProducts.map((product) => {
          if (product.shopPrices?.length > 0) {
            product.defaultShop = product.shopPrices[0].shopname;
            product.defaultPrice = product.shopPrices[0].price;
            product.defaultFinalPrice = product.shopPrices[0].FinalPrice;
          }
          return product;
        });

        setTopsall(updatedProducts);
        // setTopsall(response.data.products);
      } catch (error) {
        console.log("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, []); */

  // Fetch products on search query change
  useEffect(() => {
    if (!searchQuery) {
      setProducts([]);
      setIsSearchingProducts(false);
      return;
    }

    async function fetchProducts() {
      setLoading(true);
      try {
        const response = await makeApi(`/api/products/search?word=${searchQuery}`, "GET");
        // setProducts(response.data.products);
        const sortedProducts = response.data.products.sort(
          (a, b) => a.FinalPrice - b.FinalPrice
        );

        // Add default shop and price for products with shopPrices
        const updatedProducts = sortedProducts.map((product) => {
          if (product.shopPrices?.length > 0) {
            product.defaultShop = product.shopPrices[0].shopname;
            product.defaultPrice = product.shopPrices[0].price;
            product.defaultFinalPrice = product.shopPrices[0].FinalPrice;
          }
          return product;
        });

        setProducts(updatedProducts);
        setIsSearchingProducts(true);
      } catch (error) {
        console.log("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchProducts();
  }, [searchQuery]);


  // Load cart from localStorage
  useEffect(() => {
    const storedCart = LocalStorageUtils.getCart()
    setCart(storedCart);
    setIsInitialLoad(false);
  }, []);

  // Update localStorage when cart changes
  useEffect(() => {
    if (!isInitialLoad) {
      LocalStorageUtils.setCart(cart);
    }
  }, [cart, isInitialLoad]);

  // Clear cart periodically
  useEffect(() => {
    const interval = setInterval(() => {
      LocalStorageUtils.removeCart();
      setCart({});
    }, 600000); // 10 minutes

    return () => clearInterval(interval);
  }, []);

  const clearFromCart = (productId) => {
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      delete updatedCart[productId];
      return updatedCart;
    });
  };

  return (
    <div className="all-services-page">
      
      <div className="search-container">
        {loading && (
          <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        )}
      </div>

    
        <>
        <div className="services-container">
          {filteredMerchantDisplayList.map((merchantDisplay) => (
            <motion.div
              className="service-card"
              key={merchantDisplay.id}
              initial={{ scale: 0.8, y: 100, opecity: 0 }}
              whileInView={{ scale: 1, y: 0, opecity: 1 }}
              transition={{ duration: 0.3 }}
              onClick={() => {
                AnalyticsService.trackEvent(EVENT_NAME.MERCHANT_CLICKED, {
                  areaId: merchantDisplay.merchant.areaId,
                  merchantId: merchantDisplay.merchant.id,
                  merchantName: merchantDisplay.merchant.displayName,
                });
              }}
            >
              <Link
                to={`/merchant-products/${merchantDisplay.merchant.id}`}
                className="service-link"
              >
                <img
                  src={getImageUrl(merchantDisplay.merchant.imageUrl)}
                  alt={merchantDisplay.merchant.displayName}
                  className="service-image"
                />
                <div className="service-details">
                  <h2 className="service-title">{merchantDisplay.merchant.displayName}</h2>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        </>

      {/* Mini Cart Popup */}
      <MiniCart
        cart={cart}
        clearFromCart={clearFromCart}
        setCart={setCart}
      />
      <FooterBar/>
      <div style={{ height: "60vh" }} ></div>

    </div>
  );
}

export default Allshoppage;